webpackJsonp([22829635853097],{

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavLink = function NavLink(props) {
	  if (!props.test) {
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: props.className, to: props.url },
	      props.text
	    );
	  } else {
	    return _react2.default.createElement(
	      'span',
	      null,
	      props.text
	    );
	  }
	};
	
	function PostListItem(_ref) {
	  var node = _ref.node;
	
	  return _react2.default.createElement(
	    'div',
	    { key: node.id, className: 'views-row node' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: node.frontmatter.path },
	        node.frontmatter.title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'field-name-field-timeframe' },
	        node.frontmatter.year
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'field-name-body' },
	        _react2.default.createElement(
	          'p',
	          null,
	          node.excerpt
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'links inline' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: node.frontmatter.path, title: node.frontmatter.title },
	          'Read more'
	        )
	      )
	    )
	  );
	}
	
	function PaginationControls(_ref2) {
	  var pathContext = _ref2.pathContext;
	  var index = pathContext.index,
	      first = pathContext.first,
	      last = pathContext.last,
	      pageCount = pathContext.pageCount;
	
	  var pathPrefix = '/ongoing-conversation';
	  var previousUrl = pathPrefix + '/' + (index - 1 == 1 ? '' : (index - 1).toString());
	  var nextUrl = pathPrefix + '/' + (index + 1).toString();
	  var firstUrl = pathPrefix;
	  var lastUrl = pathPrefix + '/' + pageCount.toString();
	
	  var pageUrls = [pathPrefix];
	  for (var i = 2; i <= pageCount; i++) {
	    pageUrls.push(pathPrefix + '/' + i.toString());
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'item-list' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'pager' },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(NavLink, {
	            test: first,
	            url: firstUrl,
	            text: '« first',
	            title: 'Go to first page',
	            className: 'active'
	          })
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(NavLink, {
	            test: first,
	            url: previousUrl,
	            text: '‹ previous',
	            title: 'Go to previous page',
	            className: 'active'
	          })
	        ),
	        Array.from(Array(pageCount).keys()).map(function (key) {
	          return key + 1 != index ? _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(NavLink, {
	              test: false,
	              url: pageUrls[key],
	              text: key + 1,
	              title: 'Go to page ' + (key + 1),
	              className: 'active'
	            })
	          ) : _react2.default.createElement(
	            'li',
	            { className: 'pager-current' },
	            _react2.default.createElement(
	              'span',
	              null,
	              key + 1
	            )
	          );
	        }),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(NavLink, {
	            test: last,
	            url: nextUrl,
	            text: 'next ›',
	            title: 'Go to next page',
	            className: 'active'
	          })
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(NavLink, {
	            test: last,
	            url: lastUrl,
	            text: 'last »',
	            title: 'Go to last page',
	            className: 'active'
	          })
	        )
	      )
	    )
	  );
	}
	
	var IndexPage = function IndexPage(_ref3) {
	  var data = _ref3.data,
	      pathContext = _ref3.pathContext;
	  var group = pathContext.group,
	      pageCount = pathContext.pageCount;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'node-type-historical-content' },
	      group.map(PostListItem)
	    ),
	    _react2.default.createElement(PaginationControls, { pathContext: pathContext })
	  );
	};
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-paginate-js-bc409ff13fabcd81c361.js